import React from 'react';
import { Navigate } from 'react-router-dom';
import { ROUTE_PATHS } from '@constants';

const Root = () => {
    return <Navigate to={ROUTE_PATHS.HOME} replace />;
};

export default Root;
